export default __webpack_public_path__ + "static/media/SY.3f429b44.svg";